import { Directive, HostListener, Input } from '@angular/core';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';

/**
 * ## Usage
 *
 * ```html
 * <div ... [ga4TrackClick]="{name: C, details: {A:a, B:b}, extra: E}">product</div>
 * ```
 */
@Directive({ standalone: true, selector: '[ga4TrackClick]' })
export class Ga4TrackClickDirective {
    @Input()
    ga4TrackClick?: Gtm.IGA4TrackData;

    @Input()
    ga4TrackClickOff?: boolean;

    constructor(private gtmService: GtmService) {}

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        if (!this.ga4TrackClickOff && this.ga4TrackClick) {
            const data = this.ga4TrackClick;
            if (data) {
                this.gtmService.sendEventGA4(data.name, data.details);
            }
        }
    }
}
